import { EventHandlers, InboundAudioStatsReport, OutboundAudioStatsReport } from "modules/Call/sdk"

const coloredBorder = "rgba(39, 170, 118, 1)"
const defaultBorder = "transparent"
const inboundProperty = "--alter-call-inbound-color"
const outboundProperty = "--alter-call-outbound-color"
const MUTE_LEVEL = 0.01
function setCssVariable(name: string, value: string): void {
    document.documentElement.style.setProperty(name, value)
}

function setInboundColor(num: number) {
    setCssVariable(inboundProperty, num > MUTE_LEVEL ? coloredBorder : defaultBorder)
}
function setOutboundColor(num: number) {
    setCssVariable(outboundProperty, num > MUTE_LEVEL ? coloredBorder : defaultBorder)
}

export function handler({ stats }: EventHandlers.CallStatsReceived) {
    const inboundAudioStats = Object.values(stats.inbound).filter(
        ({ kind }) => kind === "audio"
    )[0] as InboundAudioStatsReport | undefined
    const outboundAudioStats = Object.values(stats.outbound)
        .flat()
        .filter(({ kind }) => kind === "audio")[0] as OutboundAudioStatsReport | undefined
    outboundAudioStats?.audioLevel && setOutboundColor(outboundAudioStats.audioLevel)
    inboundAudioStats?.audioLevel && setInboundColor(inboundAudioStats.audioLevel)
}

export function clearInbound() {
    setInboundColor(0)
}

export function clearOutbound() {
    setOutboundColor(0)
}

export function clearAll() {
    clearInbound()
    clearOutbound()
}
